import React, {useEffect, useState} from 'react';
import parse from "html-react-parser";
import {useTranslation} from "react-i18next";
import {useFetching} from "../../../hooks/useFetching";
import {API_GAMES_TEXT} from "../../../utils/consts";
import ApiGamesText from "../../../services/Games/Text";
import cookie from "js-cookie";
import {observer} from "mobx-react-lite";

const Text = ({ setIsLoadingText }) => {
    const {t} = useTranslation();
    const curr_lang = cookie.get('i18next');
    const [text, setText] = useState('');
    // const [text, setText] = useState('<p>Мы можем предложить широкий спектр игр с отличной графикой и звуком. <a href="https://championstudio.net/ru/games/" target="_blank">Наши игры</a> прекрасны и дают клиентам щедрые выигрыши, а <a href="https://championstudio.net/ru/game/7/" target="_blank">наша рулетка</a> покорит сердце любого азартного игрока! Всего мы предлагаем нашим партнерам более 30 различных игр, и это количество очень скоро будет только расти!</p>');

    const [FunctionApiGamesText] = useFetching(async () => {
        try {
            const response = await ApiGamesText.getApiGamesText(API_GAMES_TEXT);
            setText(response.data.text);
        } finally {
            setIsLoadingText(false);
        }
    }, []);

    useEffect(() => {
        FunctionApiGamesText();
    }, [curr_lang]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="up_catalog">
            <div className="title_block">
                <h1>{t('Games')}</h1>
                {text && parse(text)}
            </div>
        </div>
    );
};

export default observer(Text);